import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import React from "react";
import { MenuOptionType } from "../../../../../../controls";
import { Profile } from "../../../models/Profile";

type Props = {
	setProfileId: Function;
	setShowDeleteModal: Function;
	setShowCreateModal: Function;
	setModalProceduresProfile: Function;
};
export const useProfilesOptionsFunctions = ({
	setProfileId,
	setShowDeleteModal,
	setShowCreateModal,
	setModalProceduresProfile,
}: Props) => {
	const getMenuOptions = (data: Profile) => {
		let options: MenuOptionType[] = [];
		if (!data) {
			options = options.concat([
				{
					name: "New Profile",
					key: "new_profile",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
			]);
		} else {
			options = options.concat([
				{
					name: "New Profile",
					key: "new_profile",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
				{
					name: "Edit Profile",
					key: "edit_profile",
					onClick: () => {
						setProfileId(data);
						setModalProceduresProfile(true);
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Profile",
					key: "delete_profile",
					onClick: () => {
						setProfileId(data);
						setShowDeleteModal(true);
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
